export const LAYOUTCONFIG = {
    hideNavigation: true,
    defaultSidebarCollapsed: true,
    themeMode: "light",
}